import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=6c30fca1&scoped=true"
import script from "./receipt.vue?vue&type=script&lang=js"
export * from "./receipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30fca1",
  null
  
)

export default component.exports